import React, { FC } from 'react';

export const Height: FC = (props) => <div {...props} style={{ minHeight: 'calc(100vh - 80px)' }} />;
